export function demandRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_DEMAND_START":           
        case "UPDATE_DEMAND_START":           
        case "RECEIVE_DEMAND_START":           
        case "DELETE_DEMAND_START":           
        case "FETCH_INIT_DATA2_START":           
        case "FETCH_INIT_DATA3_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_DEMAND_FULFILLED":           
        case "UPDATE_DEMAND_FULFILLED":           
        case "RECEIVE_DEMAND_FULFILLED":           
        case "DELETE_DEMAND_FULFILLED":           
        case "FETCH_INIT_DATA3_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_DEMAND_ERROR":
        case "UPDATE_DEMAND_ERROR":
        case "RECEIVE_DEMAND_ERROR":
        case "DELETE_DEMAND_ERROR":
        case "FETCH_INIT_DATA3_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}